import { createApp } from "vue";

import App from "@benefit-estimator/App.vue";
import store from "@benefit-estimator/store";
import router from "@benefit-estimator/router";
import InstallPlugins from "@benefit-estimator/plugins";
import installFilters from "@benefit-estimator/filters";
import InstallMixins from "@benefit-estimator/mixins";

const app = createApp(App);
app.use(router);
app.use(store);
app.use(require("vue-cookies"));

InstallPlugins(app, store);
installFilters(app);
InstallMixins(app);

app.mount("#app");
